'use strict';
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import utils from '../utils.js';
import parseHeaders from '../helpers/parseHeaders.js';
var $internals = Symbol('internals');
function normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function normalizeValue(value) {
    if (value === false || value == null) {
        return value;
    }
    return utils.isArray(value) ? value.map(normalizeValue) : String(value);
}
function parseTokens(str) {
    var tokens = Object.create(null);
    var tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    var match;
    while ((match = tokensRE.exec(str))) {
        tokens[match[1]] = match[2];
    }
    return tokens;
}
var isValidHeaderName = function (str) { return /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim()); };
function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if (utils.isFunction(filter)) {
        return filter.call(this, value, header);
    }
    if (isHeaderNameFilter) {
        value = header;
    }
    if (!utils.isString(value))
        return;
    if (utils.isString(filter)) {
        return value.indexOf(filter) !== -1;
    }
    if (utils.isRegExp(filter)) {
        return filter.test(value);
    }
}
function formatHeader(header) {
    return header.trim()
        .toLowerCase().replace(/([a-z\d])(\w*)/g, function (w, char, str) {
        return char.toUpperCase() + str;
    });
}
function buildAccessors(obj, header) {
    var accessorName = utils.toCamelCase(' ' + header);
    ['get', 'set', 'has'].forEach(function (methodName) {
        Object.defineProperty(obj, methodName + accessorName, {
            value: function (arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
var AxiosHeaders = /** @class */ (function () {
    function AxiosHeaders(headers) {
        headers && this.set(headers);
    }
    AxiosHeaders.prototype.set = function (header, valueOrRewrite, rewrite) {
        var e_1, _a;
        var self = this;
        function setHeader(_value, _header, _rewrite) {
            var lHeader = normalizeHeader(_header);
            if (!lHeader) {
                throw new Error('header name must be a non-empty string');
            }
            var key = utils.findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || (_rewrite === undefined && self[key] !== false)) {
                self[key || _header] = normalizeValue(_value);
            }
        }
        var setHeaders = function (headers, _rewrite) {
            return utils.forEach(headers, function (_value, _header) { return setHeader(_value, _header, _rewrite); });
        };
        if (utils.isPlainObject(header) || header instanceof this.constructor) {
            setHeaders(header, valueOrRewrite);
        }
        else if (utils.isString(header) && (header = header.trim()) && !isValidHeaderName(header)) {
            setHeaders(parseHeaders(header), valueOrRewrite);
        }
        else if (utils.isObject(header) && utils.isIterable(header)) {
            var obj = {}, dest = void 0, key = void 0;
            try {
                for (var header_1 = __values(header), header_1_1 = header_1.next(); !header_1_1.done; header_1_1 = header_1.next()) {
                    var entry = header_1_1.value;
                    if (!utils.isArray(entry)) {
                        throw TypeError('Object iterator must return a key-value pair');
                    }
                    obj[key = entry[0]] = (dest = obj[key]) ?
                        (utils.isArray(dest) ? __spreadArray(__spreadArray([], __read(dest), false), [entry[1]], false) : [dest, entry[1]]) : entry[1];
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (header_1_1 && !header_1_1.done && (_a = header_1.return)) _a.call(header_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            setHeaders(obj, valueOrRewrite);
        }
        else {
            header != null && setHeader(valueOrRewrite, header, rewrite);
        }
        return this;
    };
    AxiosHeaders.prototype.get = function (header, parser) {
        header = normalizeHeader(header);
        if (header) {
            var key = utils.findKey(this, header);
            if (key) {
                var value = this[key];
                if (!parser) {
                    return value;
                }
                if (parser === true) {
                    return parseTokens(value);
                }
                if (utils.isFunction(parser)) {
                    return parser.call(this, value, key);
                }
                if (utils.isRegExp(parser)) {
                    return parser.exec(value);
                }
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    };
    AxiosHeaders.prototype.has = function (header, matcher) {
        header = normalizeHeader(header);
        if (header) {
            var key = utils.findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    };
    AxiosHeaders.prototype.delete = function (header, matcher) {
        var self = this;
        var deleted = false;
        function deleteHeader(_header) {
            _header = normalizeHeader(_header);
            if (_header) {
                var key = utils.findKey(self, _header);
                if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if (utils.isArray(header)) {
            header.forEach(deleteHeader);
        }
        else {
            deleteHeader(header);
        }
        return deleted;
    };
    AxiosHeaders.prototype.clear = function (matcher) {
        var keys = Object.keys(this);
        var i = keys.length;
        var deleted = false;
        while (i--) {
            var key = keys[i];
            if (!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    };
    AxiosHeaders.prototype.normalize = function (format) {
        var self = this;
        var headers = {};
        utils.forEach(this, function (value, header) {
            var key = utils.findKey(headers, header);
            if (key) {
                self[key] = normalizeValue(value);
                delete self[header];
                return;
            }
            var normalized = format ? formatHeader(header) : String(header).trim();
            if (normalized !== header) {
                delete self[header];
            }
            self[normalized] = normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    };
    AxiosHeaders.prototype.concat = function () {
        var _a;
        var targets = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            targets[_i] = arguments[_i];
        }
        return (_a = this.constructor).concat.apply(_a, __spreadArray([this], __read(targets), false));
    };
    AxiosHeaders.prototype.toJSON = function (asStrings) {
        var obj = Object.create(null);
        utils.forEach(this, function (value, header) {
            value != null && value !== false && (obj[header] = asStrings && utils.isArray(value) ? value.join(', ') : value);
        });
        return obj;
    };
    AxiosHeaders.prototype[Symbol.iterator] = function () {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    };
    AxiosHeaders.prototype.toString = function () {
        return Object.entries(this.toJSON()).map(function (_a) {
            var _b = __read(_a, 2), header = _b[0], value = _b[1];
            return header + ': ' + value;
        }).join('\n');
    };
    AxiosHeaders.prototype.getSetCookie = function () {
        return this.get("set-cookie") || [];
    };
    Object.defineProperty(AxiosHeaders.prototype, Symbol.toStringTag, {
        get: function () {
            return 'AxiosHeaders';
        },
        enumerable: false,
        configurable: true
    });
    AxiosHeaders.from = function (thing) {
        return thing instanceof this ? thing : new this(thing);
    };
    AxiosHeaders.concat = function (first) {
        var targets = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            targets[_i - 1] = arguments[_i];
        }
        var computed = new this(first);
        targets.forEach(function (target) { return computed.set(target); });
        return computed;
    };
    AxiosHeaders.accessor = function (header) {
        var internals = this[$internals] = (this[$internals] = {
            accessors: {}
        });
        var accessors = internals.accessors;
        var prototype = this.prototype;
        function defineAccessor(_header) {
            var lHeader = normalizeHeader(_header);
            if (!accessors[lHeader]) {
                buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        utils.isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    };
    return AxiosHeaders;
}());
AxiosHeaders.accessor(['Content-Type', 'Content-Length', 'Accept', 'Accept-Encoding', 'User-Agent', 'Authorization']);
// reserved names hotfix
utils.reduceDescriptors(AxiosHeaders.prototype, function (_a, key) {
    var value = _a.value;
    var mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: function () { return value; },
        set: function (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
utils.freezeMethods(AxiosHeaders);
export default AxiosHeaders;
